
import useApi, { Model, Query } from "../common/hooks/useApi"

export interface Agente extends Model {
    Nombre: string
    Apellido: string
    Cargo: string
    Dni: string
    Firma: string
    Matricula: string
    UnidadProduccionAgenteId?: number
}


export default () => {
    const api = useApi({ module: "Agente" });

    return {
        list: (query: Query) => api.list!<Agente>(query),
        save: (data: Partial<Agente>) => api.save!<Partial<Agente>, Agente>(data),
        delete: (id: number) => api.delete!<Agente>(id)
    };
}